// src/widgets/calendarSchedule/ui/Header.tsx
import { FC } from 'react';
import { Col, Row } from 'antd';

import { ArrowControls } from '../../arrowControls/ui';
import { MonthSelect } from '../../monthSelect/ui';
import { IHeaderCalendarProps } from '../models/types';

import styles from './styles.module.scss';

export const HeaderCalendar: FC<IHeaderCalendarProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className={styles['header-calendar']}>
      <Row className={styles['header-calendar__row']} gutter={4}>
        <Col>
          <ArrowControls value={value} onChange={onChange} direction="prev" />
        </Col>
        <Col>
          <MonthSelect
            value={value.month()}
            onChange={onChange}
            year={value.year()}
          />
        </Col>
        <Col>
          <ArrowControls value={value} onChange={onChange} direction="next" />
        </Col>
      </Row>
    </div>
  );
};
